import { organizationsAdapter } from 'src/entities/organizations/model/organizationsSlice';

import { RootState } from '@/app/model/store';

const organizationsSelectors = organizationsAdapter.getSelectors(
  (state: RootState) => state.organizations,
);

export const selectById = (organizationID: string) => (state: RootState) =>
  organizationsSelectors.selectById(state, organizationID);

export const selectLoading = (state: RootState) => state.organizations.loading;

export const { selectIds, selectAll, selectTotal, selectEntities } =
  organizationsSelectors;
